import React, { useEffect } from 'react';
import { X, AlertCircle, CheckCircle2, Info } from 'lucide-react';

const Snackbar = ({ 
  open, 
  autoHideDuration = 6000, 
  message, 
  onClose,
  severity = 'info' // 'info', 'success', 'warning', 'error'
}) => {
  useEffect(() => {
    if (open && autoHideDuration) {
      const timer = setTimeout(() => {
        onClose();
      }, autoHideDuration);
      
      return () => {
        clearTimeout(timer);
      };
    }
  }, [open, autoHideDuration, onClose]);

  if (!open) return null;
  
  const severityConfig = {
    info: {
      icon: <Info className="h-5 w-5 text-blue-500" />,
      bgColor: 'bg-blue-50 dark:bg-blue-900/20',
      borderColor: 'border-blue-200 dark:border-blue-800'
    },
    success: {
      icon: <CheckCircle2 className="h-5 w-5 text-green-500" />,
      bgColor: 'bg-green-50 dark:bg-green-900/20',
      borderColor: 'border-green-200 dark:border-green-800'
    },
    warning: {
      icon: <AlertCircle className="h-5 w-5 text-yellow-500" />,
      bgColor: 'bg-yellow-50 dark:bg-yellow-900/20',
      borderColor: 'border-yellow-200 dark:border-yellow-800'
    },
    error: {
      icon: <AlertCircle className="h-5 w-5 text-red-500" />,
      bgColor: 'bg-red-50 dark:bg-red-900/20',
      borderColor: 'border-red-200 dark:border-red-800'
    }
  };
  
  const { icon, bgColor, borderColor } = severityConfig[severity];
  
  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm">
      <div className={`flex items-center gap-3 rounded-lg ${bgColor} p-4 shadow-md border ${borderColor}`}>
        <div className="flex-shrink-0">
          {icon}
        </div>
        <div className="flex-1">
          <span className="text-sm">{message}</span>
        </div>
        <button 
          onClick={onClose}
          className="flex-shrink-0 rounded-full p-1 hover:bg-background/50"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default Snackbar;